import {type FC, useEffect} from 'react';
import styled from 'styled-components';
import {Outlet, useNavigate} from 'react-router';
import {useFocusable, FocusContext} from '@noriginmedia/norigin-spatial-navigation';
import food_info from '../../assets/amenities/food_info.png';
import bus_info from '../../assets/amenities/bus_info.png';
import remote_support from '../../assets/amenities/remote_support.png';

const Box = styled.div<{$focused?: boolean; $backgroundImage: string}>`
    background-image: ${({$backgroundImage}) => ($backgroundImage ? `url(${$backgroundImage})` : 'none')};
    background-size: cover;
    background-position: center;
    background-repeat: no-repeat;
    width: 500px;
    height: 400px;
    border-radius: 20px;
    background-color: ${(props) => (props.$focused ? '#3ab8ff' : '')};
    display: flex;
    justify-content: start;
    align-items: end;
    padding: 30px;
    font-size: 2rem;
    font-weight: bold;
    cursor: pointer;
    transition: all 0.2s ease;
    transform: ${(props) => (props.$focused ? 'scale(1.05)' : 'scale(1)')};
    box-shadow: ${(props) => (props.$focused ? '0 8px 24px rgba(0,0,0,0.3)' : '0 4px 12px rgba(0,0,0,0.1)')};

    &:hover {
        background-color: #ff8c00;
    }
`;

const AmenitiesPageWrapper = styled.div`
    width: 100%;
    height: 100%;
    justify-content: center;
    align-items: center;
    display: inline-flex;
    gap: 5rem;
`;

const MenuItem: FC<{
    title: string;
    imageSrc: string;
    onEnterPress: () => void;
}> = ({title, imageSrc, onEnterPress}) => {
    const {ref, focused} = useFocusable({
        onEnterPress,
    });

    return (
        <Box ref={ref} $focused={focused} $backgroundImage={imageSrc}>
            <div style={{display: 'block'}}>
                <div style={{fontSize: '3rem'}}>{title}</div>
                <div
                    style={{
                        fontSize: '1.5rem',
                        marginTop: '5px',
                        color: 'rgba(255, 255, 255, 0.7)',
                    }}
                >
                    {title === '대중교통 정보'
                        ? '버스 실시간 정보'
                        : title === '맛집 정보'
                          ? '주변 식당 및 메뉴 추천'
                          : '엔지니어 원격 지원 요청'}
                </div>
                <br />
            </div>
        </Box>
    );
};

const AmenitiesPage: FC = () => {
    const navigate = useNavigate();
    const {ref, focusKey} = useFocusable();

    const goTo = (name: string) => {
        navigate(`/${name}`);
    };

    const runRemoteSupport = async () => {
        try {
            const result = await window.rustdesk.launch();
            if (result.success) {
                console.log('성공적으로 요청했습니다.');
            } else {
                alert('원격 지원에 문제가 생겼습니다. 고객센터: 1551-8381');
            }
        } catch (err) {
            alert('정상 동작이 아닙니다.');
        }
    };

    return (
        <FocusContext.Provider value={focusKey}>
            <AmenitiesPageWrapper ref={ref}>
                <MenuItem title="대중교통 정보" imageSrc={bus_info} onEnterPress={() => goTo('busArrived')} />
                <MenuItem title="맛집 정보" imageSrc={food_info} onEnterPress={() => goTo('foodInfo')} />
                <MenuItem title="원격 지원" imageSrc={remote_support} onEnterPress={() => runRemoteSupport()} />
                <Outlet />
            </AmenitiesPageWrapper>
        </FocusContext.Provider>
    );
};

export default AmenitiesPage;
